import { ResultObjectType } from '@cbgms/api'

export enum VirtualSearchResultType {
  CallToActionSearchParts = 'CallToActionSearchParts',
  CallToActionCreateVehicleManually = 'CallToActionCreateVehicleManually',
  CallToActionViewMoreSupplierOrder = 'CallToActionViewMoreSupplierOrder',
  NoResults = 'NoResults'
}

export type TopSearchResultType = ResultObjectType | VirtualSearchResultType
